import { ITabsOption } from '@cp/src/components/interfaces';
import { VIEW_MODE } from './constants/constants';
import { ICallbackRequetsToday, ICallCoverageData, IPtpsOverviewMTD } from './constants/interface';

export const toggleTabOptions: ITabsOption[] = [
  {
    label: VIEW_MODE.TODAY,
    value: VIEW_MODE.TODAY
  },
  {
    label: VIEW_MODE.CYCLE,
    value: VIEW_MODE.CYCLE
  }
];

export const getCallCoverageCards = (totalCallBackRequests: ICallCoverageData) => {
  return [
    {
      title: 'Not Attempted',
      key: 'notAttempted',
      color: 'var(--navi-color-red-light)',
      count: totalCallBackRequests?.notAttempted || 0
    },
    {
      title: 'Not Connected',
      key: 'notConnected',
      color: 'var(--navi-color-orange-light)',
      count: totalCallBackRequests?.notConnected || 0
    },
    {
      title: 'Connected',
      key: 'connected',
      color: 'var(--green-base)',
      count: totalCallBackRequests?.connected || 0
    }
  ];
};

export const getPtpsOverviewCards = (ptpsOverviewMTD?: IPtpsOverviewMTD) => {
  return [
    {
      title: 'Broken PTP',
      key: 'brokenPtp',
      color: 'var(--navi-color-red-light)',
      ...ptpsOverviewMTD?.brokenPtp
    },
    {
      title: 'PTP due today',
      key: 'todayPtp',
      color: 'var(--navi-color-yellow-light)',
      ...ptpsOverviewMTD?.todayPtp
    },
    {
      title: 'Future PTP',
      key: 'futurePtp',
      color: 'var(--navi-color-orange-light)',
      ...ptpsOverviewMTD?.futurePtp
    },
    {
      title: 'No PTP',
      key: 'noPtp',
      color: 'var(--navi-toast-spinner-color-empty-area)',
      ...ptpsOverviewMTD?.noPtp
    }
  ];
};

export const getCallBackRequestsCards = (totalCallBackRequests: ICallbackRequetsToday) => {
  return [
    {
      title: 'Not Attempted',
      key: 'notAttempted',
      color: 'var(--navi-color-red-light)',
      count: totalCallBackRequests?.notAttempted || 0
    },
    {
      title: 'Not Connected',
      key: 'notConnected',
      color: 'var(--navi-color-orange-light)',
      count: totalCallBackRequests?.notConnected || 0
    },
    {
      title: 'Connected',
      key: 'connected',
      color: 'var(--green-base)',
      count: totalCallBackRequests?.connected || 0
    }
  ];
};
